export default "__VITE_ASSET__DlvS06cN__"